
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32px","height":"23px","viewBox":"0 0 32 23","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Home","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(-810.000000, -407.000000)"}},[_c('g',{attrs:{"id":"Hero-Search","transform":"translate(151.000000, 313.000000)"}},[_c('g',{attrs:{"id":"Search-box","transform":"translate(0.000000, 63.000000)"}},[_c('g',{attrs:{"id":"Button","transform":"translate(641.000000, 8.000000)"}},[_c('g',{attrs:{"id":"left-arrow","transform":"translate(34.000000, 34.500000) scale(-1, 1) translate(-34.000000, -34.500000) translate(18.000000, 23.000000)","fill":"#FFFFFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M10.273,1.009 C10.717,0.565 11.416,0.565 11.86,1.009 C12.289,1.438 12.289,2.152 11.86,2.58 L3.813,10.627 L30.367,10.627 C30.986,10.627 31.494,11.119 31.494,11.738 C31.494,12.357 30.986,12.865 30.367,12.865 L3.813,12.865 L11.86,20.897 C12.289,21.341 12.289,22.056 11.86,22.484 C11.416,22.928 10.717,22.928 10.273,22.484 L0.321,12.532 C-0.108,12.103 -0.108,11.389 0.321,10.961 L10.273,1.009 Z","id":"Path"}})])])])])])])])
          )
        }
      }
    